import { DeleteOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons'
import { Button, Col, Form, InputNumber, Row } from 'antd'
import { Gutter } from 'antd/es/grid/row'
import TextArea from 'antd/es/input/TextArea'
import React, { FunctionComponent, useCallback, useState } from 'react'

import { BUYBACK_FIELD as FIELD } from '../../../common/buybackTypes'
import { inputNumberFormatter } from '../../utils/buybackHelpers'

const gutter: [Gutter, Gutter] = [8, 8]

export const BuybackFormCommissionFragment: FunctionComponent = () => {
  const [open, setOpen] = useState(false)

  const form = Form.useFormInstance()
  const commissionAmount = Form.useWatch(FIELD.CommissionAmount)
  const baseCommissionAmount = Form.useWatch(FIELD.BaseCommissionAmount)
  const isCustomCommission = typeof commissionAmount === 'number'

  const setCustomCommission = useCallback(() => {
    form.setFieldValue(FIELD.CommissionAmount, baseCommissionAmount)
    setOpen(true)
  }, [baseCommissionAmount, form])

  const resetCustomCommission = useCallback(() => {
    form.setFieldValue(FIELD.CommissionAmount, undefined)
    setOpen(false)
  }, [form])

  return (
    <Row gutter={gutter} align="middle">
      <Col xs={24} md={13}>
        <Form.Item
          name={FIELD.RequestedAmount}
          label="Požadovaná částka nad rámec závazků"
        >
          <InputNumber
            min={0}
            step={10000}
            className="w-full"
            formatter={inputNumberFormatter}
            addonAfter="Kč"
          />
        </Form.Item>
      </Col>

      <Col xs={20} md={7} xl={8}>
        {isCustomCommission && (
          <div className="relative z-10 border-t border-gray-800 top-12 ml-2 w-16" />
        )}
        <Form.Item
          name={FIELD.BaseCommissionAmount}
          label="Odměna za zprostředkování"
        >
          <InputNumber
            min={0}
            step={10000}
            className="w-full !bg-gray-50"
            formatter={inputNumberFormatter}
            addonAfter="Kč"
            disabled
          />
        </Form.Item>
      </Col>

      <Col xs={4} md={4} xl={3}>
        <Button
          block
          title="Individuální odměna"
          className="mt-2"
          disabled={isCustomCommission}
          icon={isCustomCommission ? <LockOutlined /> : <UnlockOutlined />}
          onClick={setCustomCommission}
        />
      </Col>

      <Col md={13} />

      <Col xs={24} md={11}>
        <Form.Item
          label="Individuální odměna za zprostředkování"
          className="!mb-2"
          hidden={!isCustomCommission && !open}
        >
          <Row gutter={gutter}>
            <Col xs={20} md={19}>
              <Form.Item
                validateStatus="warning"
                className="!mb-0"
                name={FIELD.CommissionAmount}
              >
                <InputNumber
                  formatter={inputNumberFormatter}
                  addonAfter="Kč"
                  className="w-full"
                  min={0}
                  step={10000}
                />
              </Form.Item>
            </Col>
            <Col xs={4} md={5}>
              <Button
                block
                danger
                title="Použít standardní odměnu"
                icon={<DeleteOutlined />}
                onClick={resetCustomCommission}
              />
            </Col>
          </Row>
        </Form.Item>

        <Form.Item
          validateStatus="warning"
          hidden={!isCustomCommission}
          name={FIELD.CommissionNote}
          label={
            <span className="text-yellow-500">
              Nabídka podléhá schvalovacímu procesu
            </span>
          }
        >
          <TextArea
            rows={3}
            className="w-full"
            placeholder="Uveďte vysvětlení"
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
